export const HORSE_RACING_STATUSES = {
	OPEN: 1, // race is open
	SOON: 2, // race soon to start
	RUNNING: 3, // race is live
	RESULTS: 4, // race has finished
};

export const HORSE_RACING_TIME_FILTERS = {
	TODAY: 100, // filter today races
	TOMORROW: 200, // filter tomorrow races
	RESULTS: 4, // filter finished/yesterday races 
	ANTE_POST: 700, // filter antepost races
};

export const HORSE_RACING_STATUSES_CLASES = {
	[HORSE_RACING_STATUSES.SOON]: 'bto-sb-horse-status-soon',
	[HORSE_RACING_STATUSES.RUNNING]: 'bto-sb-horse-status-running',
	[HORSE_RACING_STATUSES.RESULTS]: 'bto-sb-horse-status-results',
};

export const HORSE_RACING_EVENT_STATUS_CLASSES = {
	[HORSE_RACING_STATUSES.SOON]: 'bto-sb-horse-status-soon',
	[HORSE_RACING_STATUSES.RUNNING]: 'bto-sb-widget-horse-events-running',
	[HORSE_RACING_STATUSES.RESULTS]: 'bto-sb-widget-horse-events-results',
	[HORSE_RACING_TIME_FILTERS.ANTE_POST]: 'bto-sb-widget-horse-events-antepost',
};